import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeildActivityService {

constructor(private http:HttpClient) { }


GetRecord(Token:String):Observable<Array<FeildActivity_Interface>>{
  return this.http.get(environment.BaseUrl + "Daro/FeildActivity?token="+Token).pipe(
    map(data=>{
      return data as Array<FeildActivity_Interface>
    })
  )
}

GetAll(Token:String):Observable<Array<FeildActivity_Interface>>{
  return this.http.get(environment.BaseUrl + "Daro/FeildActivity/GetAll?token="+Token).pipe(
    map(data=>{
      return data as Array<FeildActivity_Interface>
    })
  )
}

GetSingle(Token:String,id:Number):Observable<FeildActivity_Interface>{
  return this.http.get(environment.BaseUrl + "Daro/FeildActivity/GetSingle?token="+Token+"&id="+id).pipe(
    map(data=>{
      return data as FeildActivity_Interface
    })
  )
}

AddFeildActivity(model: FeildActivity_Interface,Token:String):Observable<FeildActivity_Interface>{
  const headers = new HttpHeaders().set('content-type', 'application/json');


  var body = {
    id:model.id,
    Title:model.title,
    del:false,
    Code:model.code,
    username:Token,
    subdate:null
  }


    return this.http.post(environment.BaseUrl + "Daro/FeildActivity/Add",body,{headers}).pipe(
      map(data=>{
        return data as FeildActivity_Interface
      })
    )

}

EditFeildActivity(model: FeildActivity_Interface,Token:String):Observable<FeildActivity_Interface>{
  const headers = new HttpHeaders().set('content-type', 'application/json');


  var body = {
    id:model.id,
    Title:model.title,
    del:false,
    Code:model.code,
    username:Token,
    subdate:null
  }


    return this.http.post(environment.BaseUrl + "Daro/FeildActivity/Edit",body,{headers}).pipe(
      map(data=>{
        return data as FeildActivity_Interface
      })
    )

}

DeleteFeildActivity(id:number,Token:String):Observable<FeildActivity_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/FeildActivity/Delete?id="+id+"&token="+Token).pipe(
      map(data=>{
        return data as FeildActivity_Interface
      })
    )

}

}
